import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Typography, Modal, message, Table } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import axios from 'axios';
import Layout from '../components/layout';
import { createAccountAgainstSubmission, fetchAllSubmissions } from '../services/authService';

const { Title } = Typography;

const AdminSubmissionPage = () => {
  const [submittedData, setSubmittedData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [modalContent, setModalContent] = useState('');

  // Table columns definition
  const columns = [
    {
      title: 'Gym Name',
      dataIndex: 'gymName',
      key: 'gymName',
    },
    {
      title: 'Gym Address',
      dataIndex: 'gymAddress',
      key: 'gymAddress',
    },
    {
      title: 'Contact Person Name',
      dataIndex: 'contactPersonName',
      key: 'contactPersonName',
    },
    {
      title: 'Contact Person Title',
      dataIndex: 'contactPersonTitle',
      key: 'contactPersonTitle',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => createAccount(record)}
          style={{ backgroundColor: '#242961', borderColor: '#242961' }}
        >
          Create Account
        </Button>
      ),
    },
  ];

  // Function to simulate account creation (API call)
  const createAccount = async (gymData) => {
    try {
      const response = await createAccountAgainstSubmission(gymData)
      const { email, password } = response;
      setEmail(email);
      setPassword(password);
      setModalContent(generateModalContent(gymData, email, password));
      setIsModalVisible(true); // Show modal with email and password
      setSubmittedData(prevData => {
        return prevData.map(data =>
          data.key === gymData.key ? { ...data, email, password } : data
        );
      }); // Update gym data with generated credentials
    } catch (error) {
      console.log(error)
      message.error(error? error.message:'Failed to create account');
    }
  };

  // Generate modal content
  const generateModalContent = (gymData, email, password) => {
    return `
      Gym Name: ${gymData.gymName}
      Gym Name: ${gymData.category}
      Contact Person: ${gymData.contactPersonName} (${gymData.contactPersonTitle})
      Email: ${email}
      Password: ${password}
      Phone: ${gymData.phone}
      Gym Address: ${gymData.gymAddress}
      Number of Members: ${gymData.numMembers}
      Average Visits/Day: ${gymData.avgVisits}
      Prospect Visits/Month: ${gymData.prospectVisits}
      Age Range: ${gymData.ageRange.join(', ')}
      Towels Stored: ${gymData.numTowels}
      Towel Types: ${gymData.towelTypes.join(', ')}
      Shrinkage: Gym Towels - ${gymData.towelShrinkageGym}, Bath Towels - ${gymData.towelShrinkageBath}, Pool Towels - ${gymData.towelShrinkagePool}
      Towels in Rotation: ${gymData.towelsInRotation}
      Laundry Info: Washing Machines - ${gymData.numWashingMachines}, Washes per Day - ${gymData.numWashes}
      Load Size: ${gymData.loadSize}
    `;
  };

  // Copy to clipboard
  const handleCopy = () => {
    const credentials = `Email: ${email}\nPassword: ${password}`;
    navigator.clipboard.writeText(credentials).then(() => {
      message.success('Credentials copied to clipboard');
    }).catch(() => {
      message.error('Failed to copy credentials');
    });
  };

  // Mock submission data to simulate form submissions
  const mockSubmit = (formData) => {
    const newData = {
      key: Date.now().toString(),
      gymName: formData.gymName,
      gymName: formData.category,
      gymAddress: formData.gymAddress,
      contactPersonName: formData.contactPersonName,
      contactPersonTitle: formData.contactPersonTitle,
      email: '',
      phone: formData.phone,
      numMembers: formData.numMembers,
      avgVisits: formData.avgVisits,
      prospectVisits: formData.prospectVisits,
      ageRange: formData.ageRange,
      numTowels: formData.numTowels,
      towelTypes: formData.towelTypes,
      towelShrinkageGym: formData.towelShrinkageGym,
      towelShrinkageBath: formData.towelShrinkageBath,
      towelShrinkagePool: formData.towelShrinkagePool,
      towelsInRotation: formData.towelsInRotation,
      numWashingMachines: formData.numWashingMachines,
      numWashes: formData.numWashes,
      loadSize: formData.loadSize,
    };

    setSubmittedData([...submittedData, newData]);
  };
  const fetchInitalSubmission = async()=>{
    const initialData =await fetchAllSubmissions()
    setSubmittedData(initialData)
  }

  // Dummy data for initial rendering
  useEffect(() => {
    fetchInitalSubmission()
  }, []);

  return (
    <Layout>
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <Title level={2} style={{ textAlign: 'center' }}>Admin Submission Page</Title>
      <Table columns={columns} dataSource={submittedData} pagination={false} />

      {/* Modal for displaying account creation details */}
      <Modal
        title="Account Created"
        visible={isModalVisible}
        onOk={handleCopy}
        onCancel={() => setIsModalVisible(false)}
        okText="Copy to Clipboard"
      >
        <pre>{modalContent}</pre>
      </Modal>
    </div>
    </Layout>
  );
};

export default AdminSubmissionPage;
